module.exports = __webpack_public_path__ + "static/kendrick_cancio-f31b367334a509fefcf937edd076737c.jpg";